import { get, post, patch } from '../utils/request';

export interface SidebarCaseInfo {
  id: number;
  case_number: string;
  case_name: string;
  case_type?: string;
  case_status: string;
  responsible_lawyer_name?: string;
  accept_date?: string;
}

export interface SidebarGroupInfo {
  group_id: string;
  group_name: string;
  member_count?: number;
}

export interface SidebarInfo {
  group: SidebarGroupInfo;
  cases: SidebarCaseInfo[];
  total_cases: number;
}

/**
 * Get sidebar information for a WeChat group
 */
export const getSidebarInfo = async (groupId: string): Promise<SidebarInfo> => {
  return get('/wechat/sidebar/info', {
    params: { group_id: groupId },
  });
};

/**
 * Get cases for sidebar (paginated)
 */
export const getSidebarCases = async (
  groupId: string,
  params?: {
    skip?: number;
    limit?: number;
  }
): Promise<SidebarCaseInfo[]> => {
  return get('/wechat/sidebar/cases', {
    params: {
      group_id: groupId,
      ...params,
    },
  });
};

/**
 * Quick follow-up from sidebar
 */
export const quickFollowUp = async (data: {
  case_id: number;
  content: string;
  follow_up_type?: string;
}) => {
  return post('/wechat/sidebar/follow-up', data);
};

/**
 * Quick update case status from sidebar
 */
export const updateCaseStatus = async (data: {
  case_id: number;
  case_status: string;
}) => {
  return patch('/wechat/sidebar/case-status', data);
};
